var exports = {
  "k": "xe7b6e3d6--a463e8--container",
};

module.exports = exports;
